/** Product questions (Q&A) and back-in-stock counts. Conventions: see `common.ts`. */
const questions: Record<string, string> = {
  title: 'Questions',
  subtitle: 'What customers asked about your products',

  'tabs.aria_label': 'Question status',
  'tabs.pending': 'Pending',
  'tabs.published': 'Published',
  'tabs.rejected': 'Rejected',

  'status.PENDING': 'Pending',
  'status.PUBLISHED': 'Published',
  'status.REJECTED': 'Rejected',

  search_label: 'Search questions',
  search_placeholder: 'Words in the question or answer, or a name',

  answer_label: 'Your answer',
  answer_will_email: 'The customer is emailed your answer once, when it is published.',
  answer_emailed: 'The customer has been emailed your answer.',
  answer_no_email: 'This customer left no email, so they will see the answer on the product page.',

  'actions.answer_publish': 'Answer and publish',
  'actions.save_only': 'Save without publishing',
  'actions.publish': 'Publish',
  'actions.reject': 'Reject',

  'outcome.answered': 'Answer saved and published.',
  'outcome.saved': 'Answer saved. The question is not on your store yet.',
  'outcome.PENDING': 'Question moved back to Pending.',
  'outcome.PUBLISHED': 'Question published.',
  'outcome.REJECTED': 'Question rejected. It will not show on your store.',
  'outcome.deleted': 'Question deleted.',

  'empty.title': 'No questions here',
  'empty.description': 'Questions customers ask on your product pages appear here for you to answer.',

  'delete.title': 'Delete this question?',
  'delete.message': 'The question from {name} will be removed for good.',

  'errors.update_failed': 'That did not work. Please try again.',

  'plan.message': 'Product questions come with reviews on a paid plan.',
  'plan.see_plans': 'See plans',

  'stock_alerts.waiting': '{count} waiting for restock',
};

export default questions;
